'use strict';

// import Plyr from 'plyr';
// import 'plyr/dist/plyr.css';

import { layer } from './plugins/layer/index.js';

import Lenis from 'lenis';

// import 'slick-carousel/slick/slick.css';

// import { checkAutoplaySupport } from './utiles/index.js'

// import LazyLoad from 'vanilla-lazyload';

// AOS
// import AOS from 'aos';
// import 'aos/dist/aos.css'

// import * as CookieConsent from 'vanilla-cookieconsent';
// import 'vanilla-cookieconsent/dist/cookieconsent.css';

// import { Fancybox } from '@fancyapps/ui/dist/fancybox/index.js';
// import '@fancyapps/ui/dist/fancybox/fancybox.css';

// import * as THREE from 'three';

// import Masonry from 'masonry-layout';

import './iconfont/iconfont.js';

import { initMenu } from './modules/menu.js';
import { initEmblaCarousel } from './modules/embla-carousel.js';
import { initGsap } from './modules/gsap.js';
import { initPages } from './modules/pages.js';
import { initForms } from './modules/forms.js';

// import { checkAutoplaySupport, slideDown, slideUp, checkViewTransition } from './utiles/index.js';

import Language from './language.js';
const lang = new Language();

// Initialize Lenis
const lenis = new Lenis();

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

document.addEventListener('DOMContentLoaded', () => {
	// 测试用
	const domLoop = document.querySelectorAll('[data-loop]');
	if (domLoop) {
		domLoop.forEach((item) => {
			const len = item.getAttribute('data-loop');
			const sourceItem = item.innerHTML;
			for (let i = 0; i < len; i++) {
				item.innerHTML += sourceItem;
			}
		});
	}

	// Menu
	initMenu(lenis);

	initGsap();

	initEmblaCarousel();

	initPages();

	initForms(lang);
});
